var S={default:{loader:"cylindrical"},M:{radius:"S",shadow:"S",pX:"M",pY:"M",iconSize:"M",fontSize:"M"},S:{radius:"S",shadow:"S",pX:"M",pY:"S",iconSize:"XS",fontSize:"S"}};export{S as default};
